import { screeningAction } from './constant';

const {
  CREATE_SCREENING_REQUEST,
  GET_SCREENING_REQUEST,
  RESET_CREATE_SCREENING,
  GET_DISCIPLINE_TYPE_REQUEST,
  GET_SCREENING_TYPE_REQUEST,
  EDIT_SCREENING_REQUEST,
  GET_SINGLE_SCREENING_REQUEST,
  GET_FORM_ID_FOR_SCREENING_REQUEST,
  POST_SCREENING_SUBMISSION_REQUEST,
  POST_SCREENING_SUBMISSION_RESET,
  PREVIEW_SCREENING,
} = screeningAction;

export const getScreening = (payload: object) => {
  return {
    type: GET_SCREENING_REQUEST,
    payload,
  };
};

export const getSingleScreening = (payload: object) => {
  return {
    type: GET_SINGLE_SCREENING_REQUEST,
    payload,
  };
};

export const createScreening = (payload: object) => {
  return {
    type: CREATE_SCREENING_REQUEST,
    payload,
  };
};

export const editScreening = (payload: object) => {
  return {
    type: EDIT_SCREENING_REQUEST,
    payload,
  };
};

export const resetCreateScreening = () => {
  return {
    type: RESET_CREATE_SCREENING,
  };
};

export const disciplineType = (payload: object) => {
  return {
    type: GET_DISCIPLINE_TYPE_REQUEST,
    payload,
  };
};

export const screeningType = (payload: object) => {
  return {
    type: GET_SCREENING_TYPE_REQUEST,
    payload,
  };
};

export const getFormIdForScreeningAction = (payload: object) => {
  return {
    type: GET_FORM_ID_FOR_SCREENING_REQUEST,
    payload,
  };
};

export const postScreeningSubmissionData = (payload: object) => {
  return {
    type: POST_SCREENING_SUBMISSION_REQUEST,
    payload,
  };
};

export const resetScreeningSubmissionData = () => {
  return {
    type: POST_SCREENING_SUBMISSION_RESET,
  };
};

export const previewScreeningFormAction = (payload: object) => {
  return {
    type: PREVIEW_SCREENING,
    payload,
  };
};

